import { KebabHorizontalIcon, PencilIcon, PlusIcon, SyncIcon, TrashIcon } from "@primer/octicons-react";
import { ActionList, ActionMenu, Box, Checkbox, useConfirm } from "@primer/react";
import { useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import Button from "../../../../components/ui/button";
import DataTable from "../../../../components/ui/data-table";
import Text from "../../../../components/ui/text";
import { useCommonContext } from "../../../../contexts/common";
import { useCommonSelectedHook } from "../../../../hooks/useCommonSelectedHook";
import { ePageBaseStatus } from "../../../../models/ePageBaseStatus";
import { IBoDoiCongAn } from "../../../../models/response/hoc-sinh/IBoDoiCongAn";
import { actions } from "../../../../state/actions/actionsWrapper";
import { RootState } from "../../../../state/reducers";
import { HocSinh } from "../../gia-dinh/QuanHeGiaDinhHocSinh";
import ConEmBoDoiCongAnPageEditModal from "./ConEmBoDoiCongAnPageEditModal";
interface Props {
    hocSinh: HocSinh;
}
const ConEmBoDoiCongAnPage: React.FC<Props> = ({ hocSinh }) => {
    const { status, boDoiCongAns, isShowEditModal, editingData } = useSelector((x: RootState) => x.boDoiCongAn)
    const { nam_hoc, dm_coso_id } = useCommonSelectedHook();
    const { translate } = useCommonContext();
    const confirm = useConfirm();
    const dispatch = useDispatch();
    useEffect(() => {
        if (status === ePageBaseStatus.is_not_initialization || status === ePageBaseStatus.is_need_reload) {
            handleReload();
        }
    }, [status])
    const handleReload = () => {
        dispatch(actions.boDoiCongAn.LOAD_START({ ts_hocsinh_id: hocSinh.id, nam_hoc: nam_hoc }))
    }
    const handleDelete = async (id: number) => {
        if (await confirm({
            content: translate("Base.Label.DeleteConfirm.Content"),
            title: translate("Base.Label.Confirm"),
            cancelButtonContent: translate("Base.Label.Close"),
            confirmButtonContent: translate("Base.Label.Delete"),
            confirmButtonType: "danger"
        })) {
            dispatch(actions.boDoiCongAn.DELETE_START(id))
        }
    }
    const dataSource = useMemo(() => {
        return boDoiCongAns.filter(x => x.nam_hoc == nam_hoc)
    }, [boDoiCongAns])

    return (
        <Box sx={{
            p: 3
        }}>
            <DataTable
                data={dataSource}
                isLoading={status === ePageBaseStatus.is_loading}
                title={translate("Thông tin con em bộ đội, công an")}
                searchEnable
                paging={{ enable: true }}
                actionComponent={
                    <Box sx={{
                        display: "flex"
                    }}>
                        <Button text="Gán thông tin" leadingVisual={PlusIcon}
                            size="medium"
                            variant="primary"
                            onClick={() => {
                                dispatch(actions.boDoiCongAn.SHOW_EDIT_MODAL(undefined))
                            }}
                        />
                        <Button text="Base.Label.Refresh" leadingVisual={SyncIcon}
                            size="medium"
                            sx={{ ml: 1 }}
                            onClick={() => {
                                handleReload();
                            }}
                        />
                    </Box>
                }
                columns={[
                    {
                        id: "cmd",
                        caption: "#",
                        width: "50px",
                        align: "center",
                        cellRender: (data: IBoDoiCongAn) => {
                            return (
                                <ActionMenu>
                                    <ActionMenu.Button icon={KebabHorizontalIcon} variant="invisible" sx={{ m: -1 }}>&nbsp;</ActionMenu.Button>
                                    <ActionMenu.Overlay width="auto">
                                        <ActionList>
                                            <ActionList.Item onSelect={() => {
                                                dispatch(actions.boDoiCongAn.SHOW_EDIT_MODAL(data))
                                            }}>
                                                <ActionList.LeadingVisual><PencilIcon /></ActionList.LeadingVisual>
                                                <Text text='Base.Label.Edit' />
                                            </ActionList.Item>
                                            <ActionList.Item variant="danger" onSelect={() => {
                                                handleDelete(data.id)
                                            }}>
                                                <ActionList.LeadingVisual><TrashIcon /></ActionList.LeadingVisual>
                                                <Text text='Base.Label.Delete' />
                                            </ActionList.Item>
                                        </ActionList>
                                    </ActionMenu.Overlay>
                                </ActionMenu>
                            );
                        }
                    },
                    {
                        dataField: "ten_phu_huynh",
                        caption: translate("Tên phụ huynh"),
                        width: 150

                    },
                    {
                        dataField: "co_quan_cong_tac",
                        caption: translate("Cơ quan công tác"),
                    },
                    {
                        dataField: "ghi_chu",
                        caption: translate("Thông tin khác"),
                    },
                    {
                        dataField: "is_huonguudai",
                        width: 120,
                        caption: translate("Hưởng ưu đãi"),
                        cellRender: (data: IBoDoiCongAn) => {
                            return (
                                <Box sx={{
                                    display: "flex",
                                    flexDirection: "column",
                                    alignItems: "center",
                                }}>
                                    <Checkbox checked={data.is_huonguudai} />
                                </Box>
                            )
                        }
                    },
                    {
                        dataField: "hinh_thuc_mien_giam",
                        width: 200,
                        caption: translate("Thông tin ưu đãi"),
                    },

                ]}
            />
            {isShowEditModal &&
                <ConEmBoDoiCongAnPageEditModal hocSinh={hocSinh} />
            }
        </Box>
    );
};

export default ConEmBoDoiCongAnPage;